/* PB QUICK VIEW engine (snippets/pb-quick-view.liquid). One instance per page. See the snippet header for the behaviour. */
(function () {
  'use strict';
  if (window.pbQuickView) return;
  var D = document, root = D.getElementById('pbqv');
  if (!root) return;

  var cfg = {};
  try { cfg = JSON.parse(D.getElementById('pbqv-config').textContent); } catch (e) {}
  var REDUCE = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var WIDE = window.matchMedia ? matchMedia('(min-width: 1024px)') : { matches: false };

  function q(s) { return root.querySelector(s); }
  var sheet = q('[data-pbqv-sheet]'), grab = q('[data-pbqv-grab]'), barEl = q('[data-pbqv-bar]'), scroller = q('[data-pbqv-scroll]');
  var band = q('[data-pbqv-band]'), line = q('[data-pbqv-line]'), gal = q('[data-pbqv-gal]'), stage = q('[data-pbqv-stage]');
  var track = q('[data-pbqv-track]'), prevB = q('[data-pbqv-prev]'), nextB = q('[data-pbqv-next]'), rail = q('[data-pbqv-rail]');
  var titleEl = q('[data-pbqv-title]'), priceEl = q('[data-pbqv-price]'), optsEl = q('[data-pbqv-opts]'), descEl = q('[data-pbqv-desc]');
  var qtyIn = q('[data-pbqv-qty]'), minusB = q('[data-pbqv-minus]'), plusB = q('[data-pbqv-plus]');
  var specsEl = q('[data-pbqv-specs]'), specCache = new Map();
  /*  delivery line per variant, from the specs fetch (snippets/pb-ship-line map) */
  var shipEl = q('[data-pbqv-ship]');
  function paintShip() {
    if (!shipEl) return;
    var v = state.variant, t = (state.ship && v && state.ship[String(v.id)]) || '';
    shipEl.textContent = t; shipEl.hidden = !t;
    if (fsLast) paintFs(fsLast[0], fsLast[1]);
  }
  /*  free shipping pill under the price for bags and bag bundles (window.pbFreeShip from snippets/pb-free-ship-pill);
     pre-order bags (delivery line "Ships out ...") get the pill without days */
  var fsEl = null, fsLast = null;
  /*  M-7594: the Manifest pre-order pair of the open product (the map section, same rule as the guard), for the button label only */
  var poMaps = {};
  function poLoad(h) {
    if (poMaps[h] || !h) return;
    var done = function (m) { poMaps[h] = m; if (state.open && state.handle === h) { paintAtc(); if (fsLast) paintFs(fsLast[0], fsLast[1]); } };
    fetch((cfg.root || '/').replace(/\/?$/, '/') + 'products/' + encodeURIComponent(h) + '?section_id=manifest-preorder-map', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { var m = t.match(/id="manifest-po-map"[^>]*>([\s\S]*?)<\/script>/); done(m ? (JSON.parse(m[1]).v || {}) : {}); })
      .catch(function () { done({}); });
  }
  function poNow() { var v = state.variant, m = poMaps[state.handle], r = m && v && m[String(v.id)]; return !!(r && r[2] === true && String(r[0] || '').trim() && /^\d{4}-\d{2}-\d{2}$/.test(String(r[1] || ''))); }
  function fsBag(p) { var F = window.pbFreeShip; return !!(F && p && F.isBag(p.type, p.tags)); }
  function fsPre() { if (poNow()) return true; var v = state.variant, t = (state.ship && v && state.ship[String(v.id)]) || ''; return /^(Pre-order|Ships out)/i.test(t); }
  function paintFs(price, bag) {
    fsLast = [price, bag];
    var F = window.pbFreeShip, h = F && bag ? F.html(price, { pre: !state.bundle && fsPre() }) : '';
    if (!fsEl && h && priceEl && priceEl.parentNode) {
      fsEl = document.createElement('p'); fsEl.className = 'pbqv__fsr'; fsEl.style.cssText = 'margin:6px 0 10px;min-width:0';
      priceEl.parentNode.insertBefore(fsEl, priceEl.nextSibling);
    }
    if (fsEl) { fsEl.innerHTML = h; fsEl.style.display = h ? 'flex' : 'none'; }
    /*  the pill already gives the days for an in-stock bag, so its "Arrives in" line is hidden (pre-order lines stay) */
    if (shipEl) { var st = shipEl.textContent.trim(); shipEl.hidden = !st || (!!h && !/^(Pre-order|Ships out)|left in this batch/i.test(st)); }
  }
  var bundleEl = q('[data-pbqv-bundle]'), incEl = q('[data-pbqv-inc]');
  var atc = q('[data-pbqv-atc]'), link = q('[data-pbqv-link]'), msg = q('[data-pbqv-msg]'), cartB = q('[data-pbqv-cart]'), countEl = q('[data-pbqv-count]');

  var cache = new Map();          /* handle -> Promise<product json> */
  var state = { open: false, handle: '', url: '', product: null, variant: null, sel: [], slides: [], idx: 0, tok: 0, bundle: null, bx: null, shownNow: 0 };
  var back = null, pushed = false, closeTimer = 0;

  /* ── helpers ── */
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(src, w) { if (!src) return ''; src = String(src); if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function delim(n, dec, t, d) {
    var s = (n / 100).toFixed(dec), p = s.split('.');
    return p[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t) + (p[1] ? d + p[1] : '');
  }
  function money(c) {
    var f = cfg.money || '${{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return delim(c, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(c, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(c, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delim(c, 2, "'", '.');
        default: return delim(c, 2, ',', '.');
      }
    });
  }
  function cartOpen() { return D.body.classList.contains('ab-cart-open'); }

  /* ── Bundle and save on bags (assets/pb-bundle.js): Bag only first, + 9" ITA Sling, + 7" ITA Wallet, + both, each with
     its saving; the price drops to the bag's bundle price, one add button says what it adds, the breakdown sits under the
     options, and View full product page carries the choice (?set=sling-wallet&colour=black). ── */
  function PBB() { var P = window.PBBundle; return P && P.cfg().cols.length ? P : null; }
  function qtyNow() { return Math.max(1, parseInt(qtyIn.value, 10) || 1); }
  function bxState() { return state.bx && !state.bundle ? state.bx.state() : null; }
  function paintPlainPrice(v) {
    if (v) {
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      priceEl.className = 'pbqv__price' + (sale ? ' is-sale' : '');
      priceEl.innerHTML = '<span class="pbqv__now">' + esc(money(v.price)) + '</span>' + (sale ? '<s class="pbqv__was"><span class="visually-hidden" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">Was </span>' + esc(money(v.compare_at_price)) + '</s>' : '');
    } else { priceEl.className = 'pbqv__price'; priceEl.textContent = ''; }
    paintFs(v ? v.price : 0, !!v && fsBag(state.product));
  }
  function paintAtc() {
    if (state.bundle || atc.classList.contains('is-busy')) return;
    var v = state.variant;
    if (!v) { atc.textContent = 'Unavailable'; return; }
    if (!v.available) { atc.textContent = 'Sold out'; return; }
    var s = bxState();
    if (!s && !poMaps[state.handle]) { atc.textContent = '\u00a0'; return; }
    atc.textContent = s && s.calc ? 'Add bundle to bag \u2013 ' + money(s.total) : 'Add to cart \u2013 ' + money(v.price * qtyNow());
  }
  function paintLink() {
    var s = bxState(), P = PBB(), base = state.url || (state.product && state.product.url) || '#';
    link.href = s && s.calc && P ? P.link(base, s) : base;
  }
  function onBundle(s) {
    if (state.bundle || !state.variant) return;
    var P = PBB();
    if (s && s.calc && P) {
      var l = s.calc.lines[0];
      priceEl.className = 'pbqv__price is-sale is-bundle';
      priceEl.innerHTML = P.priceHTML(l.unitWas, l.unitNow, 'Bundle price', false);
      P.tween(priceEl.querySelector('[data-pbx-num]'), state.shownNow || state.variant.price, l.unitNow, false);
      state.shownNow = l.unitNow;
      paintFs(l.unitNow, fsBag(state.product));
    } else { state.shownNow = 0; paintPlainPrice(state.variant); }
    paintAtc(); paintLink();
  }
  function mountBundle(p) {
    state.bx = null; state.shownNow = 0;
    if (!bundleEl) return;
    var P = PBB(), c = P && P.cfg();
    var ok = !!P && !!p && P.eligible(p.id) && String(p.id) !== String(c.sling.id) && String(p.id) !== String(c.wallet.id);
    if (!ok) { bundleEl.hidden = true; bundleEl.innerHTML = ''; return; }
    bundleEl.hidden = false;
    /* M-9213: free wallet with this bag (assets/pb-free-wallet.js): no paid 7" wallet options, the gift goes in with the add */
    var FW = window.PBFreeWallet, fw = !!(FW && FW.eligible && FW.eligible(p.id));
    state.fw = fw ? FW.cfg() : null;
    state.bx = P.mount(bundleEl, {
      /* M-E1F2 / M-B87E: one list of three options while the free wallet is on (same as the product page) */
      /* M-C8F6: the same two options as the bag page (Bag + free wallet, Bag only); bundles live on the bag page */
      opts: fw ? ['none', 'bag'] : undefined,
      labels: fw ? { none: 'Bag + free wallet', bag: 'Bag only' } : undefined,
      subs: fw ? { none: P.esc(state.fw.name || '7" mini ITA phone wallet') + (state.fw.was ? ' \u00b7 <s><span class="pbfw__sr">Was </span>' + P.esc(P.money(state.fw.was)) + '</s> <b>Free</b>' : ''), bag: 'No wallet' } : undefined,
      gift: fw ? { img: state.fw.gimg || '', opts: ['none'] } : undefined,
      cur: false, thumbs: true, head: 'Choose your option', sub: fw ? '' : 'Add mini ITA bags and save an extra ' + P.maxPct() + '%',
      bag: function () { var v = state.variant || {}, fi = v.featured_image ? v.featured_image.src : (p.featured_image || ''); return { name: P.shortName(p.id, p.title), price: v.price || 0, compare: v.compare_at_price || 0, qty: qtyNow(), elig: true, avail: !!v.available, solo: /\bb[\s-]?grade\b/i.test(v.title || '') && (p.variants || []).some(function (x) { return x.available && !/\bb[\s-]?grade\b/i.test(x.title || ''); }), img: fi ? img(fi, 160) : '', colour: (v.title || '') + ' ' + (p.title || '') }; },
      onChange: function (s) { onBundle(s); paintInc(s); }
    });
    paintInc();
  }
  /* M-9213 What's included under the options: the bag's spec data comes with the specs fetch (sections/pb-preview-specs) */
  function paintInc(s) {
    if (!incEl) return;
    var P = PBB(), base = state.product && state.incH === state.product.handle ? state.inc : null;
    if (!P || !P.incHTML || !base || state.bundle || !state.bx) { incEl.hidden = true; incEl.innerHTML = ''; return; }
    var v = state.variant || {}, t = v.title && !/^(default title|bag only)/i.test(v.title) ? String(v.title).replace(/\s*[\/|-]?\s*b[\s-]?grade.*$/i, '').replace(/\s*\/\s*new$/i, '') : '';
    var fwn = state.fw && (s || state.bx.state()).opt !== 'bag' && !/\bb[\s-]?grade\b/i.test(v.title || '') ? String(state.fw.name || '').replace(/^7" ITA Phone Wallet/i, '7" mini ITA phone wallet') : '';
    incEl.innerHTML = P.incHTML(base, s || state.bx.state(), { name: state.product ? P.shortName(state.product.id, '') : '', colour: t, fw: fwn, fwWas: fwn && state.fw ? state.fw.was : 0, bgrade: /\bb[\s-]?grade\b/i.test(v.title || '') });
    incEl.hidden = false;
  }
  function store(n) { try { return window.Alpine && Alpine.store ? Alpine.store(n) : null; } catch (e) { return null; } }

  /* ── data: /products/<handle>.js, one request per handle ── */
  function load(handle) {
    if (cache.has(handle)) return cache.get(handle);
    var u = (cfg.root || '/').replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js';
    function get() { return fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }); }
    /* one quiet retry: a busy storefront can answer the first call with a challenge page instead of JSON */
    var p = get().catch(function () { return new Promise(function (res) { setTimeout(res, 900); }).then(get); });
    p.catch(function () { cache.delete(handle); });
    cache.set(handle, p);
    return p;
  }
  /* specs: sections/pb-preview-specs rendered for this product, fetched on open (never with the page), one request per handle */
  function loadSpecs(handle) {
    if (specCache.has(handle)) return specCache.get(handle);
    var u = (cfg.root || '/').replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '?section_id=pb-preview-specs';
    function get() { return fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); }); }
    var p = get().catch(function () { return new Promise(function (res) { setTimeout(res, 1200); }).then(get); });
    p.catch(function () { specCache.delete(handle); });
    specCache.set(handle, p);
    return p;
  }
  function paintSpecs(handle, tok) {
    if (!specsEl) return;
    specsEl.innerHTML = '';
    loadSpecs(handle).then(function (html) {
      if (tok !== state.tok || !state.open) return;
      var d = D.createElement('div'); d.innerHTML = html;
      var ij = d.querySelector('[data-pb-inc-json]'); state.inc = null; state.incH = handle; if (ij) { try { state.inc = JSON.parse(ij.textContent); } catch (e) {} } paintInc();
      var sm = d.querySelector('[data-pb-ship-map]'); state.ship = null;
      if (sm) { try { state.ship = JSON.parse(sm.textContent); } catch (e) {} }
      paintShip();
      var b = d.querySelector('[data-pb-bs]'); var css = d.querySelector('link[rel="stylesheet"]');
      specsEl.innerHTML = '';
      if (!b) return;
      if (css && !D.querySelector('link[href="' + css.getAttribute('href') + '"]')) D.head.appendChild(css);
      specsEl.appendChild(b);
      requestAnimationFrame(function () { gkey = ''; geo(); pin(); });
    }).catch(function () {});
  }
  function handleOf(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* description -> { short: first paragraph, long: the rest }, media, styles and attributes stripped (as the Find your fit view) */
  function desc(html) {
    var d = D.createElement('div'); d.innerHTML = html || '';
    [].slice.call(d.querySelectorAll('img,picture,figure,video,iframe,script,style,svg,table,meta,link,form,input,button,noscript,template,hr,object,embed')).forEach(function (n) { n.remove(); });
    [].slice.call(d.querySelectorAll('h1,h2,h3,h4,h5,h6')).forEach(function (h) { var p = D.createElement('p'), b = D.createElement('strong'); b.textContent = h.textContent; p.appendChild(b); h.replaceWith(p); });
    [].slice.call(d.querySelectorAll('a,span,font,u,div,section,article')).forEach(function (n) {
      if (/^(DIV|SECTION|ARTICLE)$/.test(n.tagName)) { var p = D.createElement('p'); while (n.firstChild) p.appendChild(n.firstChild); n.replaceWith(p); }
      else n.replaceWith.apply(n, [].slice.call(n.childNodes));
    });
    [].slice.call(d.querySelectorAll('*')).forEach(function (n) { while (n.attributes.length) n.removeAttribute(n.attributes[0].name); });
    [].slice.call(d.querySelectorAll('p p')).forEach(function (n) { n.replaceWith.apply(n, [].slice.call(n.childNodes)); });
    [].slice.call(d.querySelectorAll('p,li')).forEach(function (n) { if (!n.textContent.replace(/\s+/g, '').length) n.remove(); });
    var kids = [].slice.call(d.children);
    if (!kids.length) { var t = d.textContent.trim(); return { short: t ? '<p>' + esc(t) + '</p>' : '', long: '' }; }
    var first = kids.shift();
    return { short: first.outerHTML, long: kids.map(function (k) { return k.outerHTML; }).join('') };
  }

  /* ── geometry: size the photo to the sheet; on phones/tablets it shrinks with the scroll ── */
  var MIN = 0.5, h0 = 0, gkey = '', raf = 0, small = false;
  function geo() {
    var W = sheet.clientWidth, H = scroller.clientHeight, hasRail = state.slides.length > 1, wide = WIDE.matches;
    var key = W + 'x' + H + (hasRail ? 'r' : '') + (wide ? 'w' : '');
    if (key === gkey || !W || !H) return; gkey = key;
    var rw = W < 500 ? 60 : 72, st;
    if (wide) { rw = 76; st = Math.floor(Math.min(W * 0.56 - 28 - (hasRail ? rw + 8 : 0), H - 48, 640)); }
    else st = Math.floor(Math.min(W - 32 - (hasRail ? rw + 8 : 0), H * 0.6, 560));
    st = Math.max(160, st);
    h0 = st + 16;
    root.style.setProperty('--qv-st', st + 'px'); root.style.setProperty('--qv-rail', rw + 'px');
    root.style.setProperty('--qv-gw', (hasRail ? st + 8 + rw : st) + 'px'); root.style.setProperty('--qv-h0', h0 + 'px');
    snapTo(state.idx, true);
  }
  function pin() {
    raf = 0;
    if (WIDE.matches || !h0) { band.style.transform = gal.style.transform = line.style.transform = ''; if (small) { small = false; sheet.classList.remove('is-small'); } return; }
    var y = Math.max(0, scroller.scrollTop), k = Math.max(MIN, Math.min(1, (h0 - y) / h0));
    band.style.transform = 'scaleY(' + k + ')'; gal.style.transform = 'scale(' + k + ')';
    line.style.transform = 'translateY(' + (Math.round(h0 * k) - 1) + 'px)';
    var sm = k < 0.86; if (sm !== small) { small = sm; sheet.classList.toggle('is-small', sm); }
  }
  scroller.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(pin); }, { passive: true });
  var rzT = 0;
  window.addEventListener('resize', function () { if (!state.open) return; clearTimeout(rzT); rzT = setTimeout(function () { geo(); pin(); }, 60); }, { passive: true });
  stage.addEventListener('click', function (e) { if (!small || e.target.closest('button')) return; try { scroller.scrollTo({ top: 0, behavior: REDUCE ? 'auto' : 'smooth' }); } catch (err) { scroller.scrollTop = 0; } });

  /* ── carousel: native scroll-snap track (swipe), arrows hidden at the ends, vertical rail ── */
  function renderMedia(list, startIdx) {
    state.slides = list;
    track.innerHTML = list.map(function (m, n) {
      return '<figure class="pbqv__slide" role="group" aria-roledescription="slide" aria-label="' + (n + 1) + ' of ' + list.length + '">' +
        '<img src="' + esc(img(m.src, 900)) + '" srcset="' + esc(img(m.src, 600)) + ' 600w, ' + esc(img(m.src, 900)) + ' 900w, ' + esc(img(m.src, 1400)) + ' 1400w" sizes="(min-width:1024px) 600px, 90vw" alt="' + esc(m.alt || '') + '"' +
        (n > 1 ? ' loading="lazy"' : '') + ' decoding="async" draggable="false"></figure>';
    }).join('');
    if (list.length > 1) {
      rail.innerHTML = list.map(function (m, n) {
        return '<button type="button" class="pbqv__tb" data-i="' + n + '" aria-label="Photo ' + (n + 1) + '"><img src="' + esc(img(m.src, 160)) + '" alt="" decoding="async"></button>';
      }).join('');
      rail.hidden = false;
    } else { rail.innerHTML = ''; rail.hidden = true; }
    gkey = ''; geo();
    state.idx = -1; snapTo(startIdx || 0, true);
  }
  function setIdx(i) {
    var n = state.slides.length;
    i = Math.max(0, Math.min(n - 1, i));
    if (i === state.idx) return;
    state.idx = i;
    prevB.hidden = i <= 0; nextB.hidden = i >= n - 1;
    [].slice.call(rail.children).forEach(function (b, k) { var on = k === i; b.classList.toggle('is-on', on); if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
    var tb = rail.children[i];
    if (tb && !rail.hidden) {   /* keep the active thumb in view inside the rail only (never scrollIntoView: it would move the sheet) */
      var top = tb.offsetTop, bot = top + tb.offsetHeight;
      if (top < rail.scrollTop) rail.scrollTop = top - 2; else if (bot > rail.scrollTop + rail.clientHeight) rail.scrollTop = bot - rail.clientHeight + 2;
    }
  }
  function snapTo(i, instant) {
    var n = state.slides.length; if (!n) { prevB.hidden = nextB.hidden = true; return; }
    i = Math.max(0, Math.min(n - 1, i));
    var w = track.clientWidth;
    if (w) {
      try { track.scrollTo({ left: i * w, behavior: instant || REDUCE ? 'auto' : 'smooth' }); } catch (e) { track.scrollLeft = i * w; }
    }
    setIdx(i);
  }
  var tsT = 0;
  track.addEventListener('scroll', function () {
    var w = track.clientWidth; if (!w) return;
    clearTimeout(tsT);
    tsT = setTimeout(function () { setIdx(Math.round(track.scrollLeft / w)); }, 60);
  }, { passive: true });
  prevB.addEventListener('click', function () { snapTo(state.idx - 1); });
  nextB.addEventListener('click', function () { snapTo(state.idx + 1); });
  rail.addEventListener('click', function (e) { var b = e.target.closest('.pbqv__tb'); if (b) snapTo(+b.getAttribute('data-i')); });

  /* ── product rendering ── */
  function mediaList(p) {
    var list = (p.media || []).map(function (m) {
      var src = m.media_type === 'image' ? m.src : (m.preview_image && m.preview_image.src);
      return src ? { id: m.id, src: src, alt: m.alt || p.title } : null;
    }).filter(Boolean);
    if (!list.length && p.images) list = p.images.map(function (s, n) { return { id: 'i' + n, src: s, alt: p.title }; });
    return list;
  }
  function variantMediaIdx(v) {
    if (!v) return -1;
    var fm = v.featured_media && v.featured_media.id;
    for (var n = 0; n < state.slides.length; n++) if (fm && state.slides[n].id === fm) return n;
    var fi = v.featured_image && v.featured_image.src;
    if (fi) { var base = String(fi).split('?')[0].replace(/^https?:/, ''); for (var k = 0; k < state.slides.length; k++) if (String(state.slides[k].src).split('?')[0].replace(/^https?:/, '') === base) return k; }
    return -1;
  }
  function realOptions(p) { return (p.options || []).filter(function (o) { return !(p.options.length === 1 && o.values && o.values.length === 1 && /default title/i.test(o.values[0])); }); }
  function findVariant(p, sel) { return (p.variants || []).filter(function (v) { return sel.every(function (s, n) { return v.options[n] === s; }); })[0] || null; }
  function isSwatchOpt(name) { return /colou?r|finish|style|design|print|shade|pattern/i.test(name || ''); }
  function isColourOpt(name) { return /^\s*colou?rs?\s*$/i.test(name || ''); }
  /*  a solid fill for a colour value, the same table as snippets/pb-colour-fill.liquid (words in brackets win: "Cotton Corduroy (Beige)") */
  var FILLS = [['rose gold', '#d4a28c'], ['gold|brass', '#c9a94a'], ['bronze|copper', '#a8693c'], ['black|charcoal|onyx', '#17181c'], ['chocolate|brown|coffee|mocha', '#5b3a26'],
    ['camel|caramel|tan|khaki|toffee', '#b98b5c'], ['beige|cream|natural|sand|oat|ivory|stone|latte', '#e7dfd0'], ['forest|olive', '#2f4a35'], ['green|sage|mint', '#5e8f5a'],
    ['cobalt', '#0034d3'], ['navy', '#1f2a52'], ['blue|sky', '#3d74d6'], ['grey|gray|silver', '#8c919b'], ['white', '#ffffff'], ['clear|transparent', '#eef3fb'],
    ['pink|blush|rose', '#e9a8c2'], ['red|burgundy|wine', '#b8323a'], ['purple|lilac|lavender', '#8e6cc2'], ['yellow|mustard', '#efc54a'], ['orange', '#e5792a']];
  function colourWord(v) { v = String(v || ''); var m = /\(([^)]*)\)/.exec(v); return (m ? m[1] : v).trim(); }
  function colourFill(v) { var n = colourWord(v).toLowerCase(); for (var i = 0; i < FILLS.length; i++) if (new RegExp(FILLS[i][0]).test(n)) return FILLS[i][1]; return ''; }

  /*  New 2026 pill above the title for 2026 bags (product tag new-2026), the same pill as the bag finder */
  var newEl = null;
  function setNew(on) {
    if (!newEl && on && titleEl && titleEl.parentNode) {
      newEl = document.createElement('span'); newEl.className = 'pbqv__new'; newEl.textContent = 'New 2026';
      newEl.style.cssText = "align-items:center;width:max-content;max-width:100%;margin:0 0 8px;padding:3px 10px;border-radius:999px;background:#eef2ff;color:#0033cc;font:600 12px/1.3 var(--pb-font-ui,'Inter Tight',system-ui,sans-serif);letter-spacing:.02em;text-transform:none;white-space:nowrap";
      titleEl.parentNode.insertBefore(newEl, titleEl);
    }
    if (newEl) newEl.style.display = on ? 'flex' : 'none';
  }

  function skeleton(title) {
    root.classList.add('is-loading'); root.classList.remove('is-error');
    setNew(false);
    titleEl.textContent = title || '';
    priceEl.className = 'pbqv__price'; priceEl.innerHTML = '<span class="pbqv__sk pbqv__sk--price"></span>';
    paintFs(0, false);
    optsEl.innerHTML = '<span class="pbqv__sk pbqv__sk--lab"></span><div style="margin:0 0 16px"><span class="pbqv__sk pbqv__sk--sw"></span><span class="pbqv__sk pbqv__sk--sw"></span></div>';
    descEl.innerHTML = '<span class="pbqv__sk pbqv__sk--ln" style="width:92%"></span><span class="pbqv__sk pbqv__sk--ln" style="width:84%"></span><span class="pbqv__sk pbqv__sk--ln" style="width:60%"></span>';
    atc.disabled = true; atc.textContent = '\u00a0'; showMsg('');
  }

  function render(p, preferVid) {
    root.classList.remove('is-loading', 'is-error');
    state.product = p; state.bx = null; state.shownNow = 0;
    titleEl.textContent = p.title; barEl.textContent = p.title;
    setNew((p.tags || []).indexOf('new-2026') > -1);
    var opts = realOptions(p);
    var v = null;
    if (preferVid) v = (p.variants || []).filter(function (x) { return String(x.id) === String(preferVid); })[0] || null;
    if (!v) v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || null;
    state.sel = v ? v.options.slice() : [];
    var ml = mediaList(p); state.slides = ml;   /* the chosen colour's photo is looked up in this product's slides, not the loading slide */
    renderMedia(ml, Math.max(0, variantMediaIdx(v)));
    /* options */
    function swSrc(n, val) {
      var vv = (p.variants || []).filter(function (x) { return x.options[n] === val && (x.featured_image || x.featured_media); })[0];
      return vv && (vv.featured_image ? vv.featured_image.src : vv.featured_media && vv.featured_media.preview_image && vv.featured_media.preview_image.src);
    }
    optsEl.innerHTML = opts.map(function (o, n) {
      /*  colours: swatch + name chips with solid fills (snippets/pb-colour-fill.liquid), when every value has a known fill */
      var fl = isColourOpt(o.name) && o.values.every(function (val) { return !!colourFill(val); });
      /* photo swatches only when EVERY value has its own photo, so a row never mixes photo and plain chips */
      var sw = !fl && isSwatchOpt(o.name) && o.values.every(function (val) { return !!swSrc(n, val); });
      /* other options: 3 values or fewer = pills ("4-pack · $15" when prices differ); more = a dropdown that names prices */
      var plain = !fl && !sw && !isColourOpt(o.name), lng = plain && o.values.length > 3;
      if (lng) return '<fieldset class="pbqv__opt" data-o="' + n + '" data-long><legend class="pbqv__label"><label for="pbqv-sel-' + n + '">' + esc(o.name) + '</label></legend><div class="pbqv__selw"><select class="pbqv__select" id="pbqv-sel-' + n + '" data-o-sel>' +
        o.values.map(function (val) { return '<option value="' + esc(val) + '">' + esc(val) + '</option>'; }).join('') + '</select></div></fieldset>';
      return '<fieldset class="pbqv__opt" data-o="' + n + '"' + (fl ? ' data-fill' : '') + (plain ? ' data-pills' : '') + '><legend class="pbqv__label">' + esc(isColourOpt(o.name) ? 'Colour' : o.name) + ': <b data-o-val></b></legend><div class="pbqv__vals">' +
        o.values.map(function (val) {
          var thumb = '';
          if (fl) return '<button type="button" class="pbqv__sw has-fill" data-v="' + esc(val) + '" aria-pressed="false"><i style="background:' + esc(colourFill(val)) + '" aria-hidden="true"></i><span>' + esc(colourWord(val)) + '</span></button>';
          if (sw) {
            var src = swSrc(n, val);
            if (src) thumb = '<img src="' + esc(img(src, 96)) + '" alt="" loading="lazy" decoding="async">';
          }
          if (plain) return '<button type="button" class="pbqv__sw pbqv__pill" data-v="' + esc(val) + '" aria-pressed="false"><span>' + esc(val) + '</span><small class="pbqv__pp" data-pp></small></button>';
          return '<button type="button" class="pbqv__sw' + (thumb ? ' has-img' : '') + '" data-v="' + esc(val) + '" aria-pressed="false">' + thumb + '<span>' + esc(val) + '</span></button>';
        }).join('') + '</div></fieldset>';
    }).join('');
    /* description */
    var d = desc(p.description);
    descEl.innerHTML = d.short ? '<div class="pbqv__short">' + d.short + '</div>' + (d.long ? '<div class="pbqv__long" id="pbqv-long" hidden>' + d.long + '</div><button type="button" class="pbqv__rm" aria-expanded="false" aria-controls="pbqv-long"><span>Read more</span><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 9l8 8 8-8" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' : '') : '';
    link.href = state.url || p.url;
    setVariant(v, false);
    mountBundle(p);
    /* the full description shows when it fits without scrolling the Preview; Read more only when it would overflow */
    var fitTok = ++descFitTok;
    requestAnimationFrame(function () { fitDesc(fitTok); }); setTimeout(function () { fitDesc(fitTok); }, 380);
  }
  var descFitTok = 0;
  function fitDesc(tok) {
    if (tok !== descFitTok) return;
    var long = descEl.querySelector('.pbqv__long'), b = descEl.querySelector('.pbqv__rm');
    if (!long || !b || b.hasAttribute('data-user') || !scroller || !scroller.clientHeight) return;
    var was = long.hidden; long.hidden = false;
    var fits = scroller.scrollHeight <= scroller.clientHeight + 4;
    if (fits) { b.hidden = true; b.setAttribute('aria-expanded', 'true'); }
    else { long.hidden = was && b.getAttribute('aria-expanded') !== 'true'; b.hidden = false; }
  }

  function setVariant(v, moveMedia) {
    var p = state.product; state.variant = v; setTimeout(function () { paintInc(); }, 0);
    /* swatch states */
    [].slice.call(optsEl.querySelectorAll('.pbqv__opt')).forEach(function (fs) {
      var n = +fs.getAttribute('data-o');
      var cur = state.sel[n];
      /* the price each value would cost with the other choices kept; shown only when the values differ */
      var pr = {}, seen = {}, nDiff = 0;
      (((p.options || [])[n] || {}).values || []).forEach(function (val) {
        var t2 = state.sel.slice(); t2[n] = val;
        var mv = findVariant(p, t2) || (p.variants || []).filter(function (x) { return x.options[n] === val; })[0];
        if (mv) { pr[val] = mv.price; if (!seen[mv.price]) { seen[mv.price] = 1; nDiff++; } }
      });
      var showPr = nDiff > 1;
      var sel = fs.querySelector('[data-o-sel]');
      if (sel) {
        [].slice.call(sel.options).forEach(function (op) { var t3 = state.sel.slice(); t3[n] = op.value; var mm = findVariant(p, t3); op.textContent = op.value + (showPr && pr[op.value] != null ? ', ' + money(pr[op.value]) : '') + (mm && !mm.available ? ' (sold out)' : ''); });
        if (sel.value !== cur) sel.value = cur;
        return;
      }
      [].slice.call(fs.querySelectorAll('[data-pp]')).forEach(function (sp) { var vv = sp.parentNode.getAttribute('data-v'); sp.textContent = showPr && pr[vv] != null ? ' · ' + money(pr[vv]).replace(/[.,]00(?!\d)/, '') : ''; });
      var lab = fs.querySelector('[data-o-val]'); if (lab) lab.textContent = fs.hasAttribute('data-fill') ? colourWord(cur) : (cur || '');
      [].slice.call(fs.querySelectorAll('.pbqv__sw')).forEach(function (b) {
        var val = b.getAttribute('data-v'), on = val === cur;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var test = state.sel.slice(); test[n] = val;
        var match = findVariant(p, test);
        var out = !match || !match.available;
        b.classList.toggle('is-out', out);
        b.setAttribute('aria-label', val + (out ? ', sold out' : ''));
      });
    });
    /* price */
    state.shownNow = 0; paintPlainPrice(v);
    /* quantity rule */
    var rule = (v && v.quantity_rule) || { min: 1, max: null, increment: 1 };
    qtyIn.min = rule.min || 1; qtyIn.step = rule.increment || 1; if (rule.max) qtyIn.max = rule.max; else qtyIn.removeAttribute('max');
    clampQty();
    /* button */
    atc.disabled = !v || !v.available;
    showMsg('');
    if (state.bx) state.bx.refresh(); else { paintAtc(); paintLink(); }
    paintShip();
    if (moveMedia) { var mi = variantMediaIdx(v); if (mi > -1) snapTo(mi); }
    /* keep the address bar on the chosen variant (same history entry) */
    if (state.open && pushed && v && state.url) {
      try { history.replaceState(history.state, '', state.url.split('?')[0] + (realOptions(p).length ? '?variant=' + v.id : '')); } catch (e) {}
    }
  }
  optsEl.addEventListener('change', function (e) {
    var sl = e.target.closest && e.target.closest('[data-o-sel]'); if (!sl || state.bundle || !state.product) return;
    pickOpt(+sl.closest('.pbqv__opt').getAttribute('data-o'), sl.value);
  });
  optsEl.addEventListener('click', function (e) {
    if (state.bundle) { bundlePick(e); return; }
    var b = e.target.closest('.pbqv__sw'); if (!b || !state.product) return;
    pickOpt(+b.closest('.pbqv__opt').getAttribute('data-o'), b.getAttribute('data-v'));
  });
  function pickOpt(n, val) {
    var p = state.product;
    state.sel[n] = val;
    var v = findVariant(p, state.sel);
    if (!v || !v.available) {   /* closest available variant that keeps this choice */
      var alt = (p.variants || []).filter(function (x) { return x.options[n] === val && x.available; })[0];
      if (alt) { v = alt; state.sel = alt.options.slice(); }
    }
    setVariant(v, true);
  }
  descEl.addEventListener('click', function (e) {
    var b = e.target.closest('.pbqv__rm'); if (!b) return;
    b.setAttribute('data-user', '');
    var long = descEl.querySelector('.pbqv__long'), open = b.getAttribute('aria-expanded') !== 'true';
    if (long) long.hidden = !open;
    b.setAttribute('aria-expanded', open ? 'true' : 'false'); b.querySelector('span').textContent = open ? 'Read less' : 'Read more';
  });

  /* ── quantity ── */
  function clampQty() {
    var min = +qtyIn.min || 1, step = +qtyIn.step || 1, max = qtyIn.max ? +qtyIn.max : Infinity;
    var v = parseInt(qtyIn.value, 10); if (!(v >= min)) v = min;
    v = min + Math.round((v - min) / step) * step; if (v > max) v = max;
    qtyIn.value = v; minusB.disabled = v <= min; plusB.disabled = v + step > max;
    return v;
  }
  minusB.addEventListener('click', function () { qtyIn.value = (parseInt(qtyIn.value, 10) || 1) - (+qtyIn.step || 1); clampQty(); });
  plusB.addEventListener('click', function () { qtyIn.value = (parseInt(qtyIn.value, 10) || 1) + (+qtyIn.step || 1); clampQty(); });
  qtyIn.addEventListener('change', clampQty);
  function qtyChanged() { if (state.bundle) return; if (state.bx) state.bx.refresh(); else paintAtc(); }
  [minusB, plusB].forEach(function (b) { b.addEventListener('click', qtyChanged); });
  qtyIn.addEventListener('change', qtyChanged);

  function showMsg(t) { msg.textContent = t || ''; msg.hidden = !t; }

  /* ── cart: the theme's drawer opens ABOVE this view (Artist Booths recipe: optimistic open + skeleton row + sections in the add) ── */
  function countFromDom() {
    var b = D.querySelector('#cart-icon-bubble span');
    var n = b ? parseInt(b.textContent, 10) : NaN;
    if (isNaN(n)) { var ch = store('xCartHelper'); n = ch && typeof ch.currentItemCount === 'number' ? ch.currentItemCount : NaN; }
    return n;
  }
  function setCount(n) { if (isNaN(n)) return; countEl.textContent = n > 99 ? '99+' : String(n); countEl.hidden = !(n > 0); cartB.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items')); if (window.pbCartCount) window.pbCartCount.set(n); }
  function refreshCount() {
    fetch((cfg.root || '/').replace(/\/?$/, '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () { setCount(countFromDom()); });
  }
  var cartOpener = null;
  function openCart(from) {
    cartOpener = from || null;
    var mc = store('xMiniCart');
    if (!mc || !mc.openCart) { location.href = cfg.cartUrl || '/cart'; return; }
    try { if (mc.needReload && mc.reLoad) mc.reLoad(); } catch (e) {}
    mc.openCart();
  }
  cartB.addEventListener('click', function () { openCart(cartB); });

  function addToCart() {
    var B = state.bundle, v = state.variant;
    if (atc.classList.contains('is-busy')) return;
    if (B) { if (!bundleReady(B)) return; } else if (!v || !v.available) return;
    var qty = B ? 1 : clampQty(), A = store('xMiniCart') ? window.Alpine : null;
    atc.classList.add('is-busy'); showMsg('');
    cartOpener = atc;
    /* optimistic: the drawer slides in now, the new line lands a beat later */
    try { var mc = A && Alpine.store('xMiniCart'); if (mc && mc.openCart) mc.openCart(); } catch (e) {}
    try {
      var host = D.querySelector('#CartDrawer-Form') || D.querySelector('#CartDrawer .ab-cart-scroll');
      if (host && !host.querySelector('.ab-atc-skel')) { var sk = D.createElement('div'); sk.className = 'ab-atc-skel'; sk.innerHTML = '<div class="ab-atc-skel-img"></div><div class="ab-atc-skel-lines"><i></i><i></i></div>'; host.insertBefore(sk, host.firstChild); }
    } catch (e) {}
    var bs = B ? null : bxState();
    var body = { items: B ? bOn(B).map(function (it) { return { id: it.v.id, quantity: 1 }; }) : [{ id: v.id, quantity: qty }].concat(bs && bs.calc ? bs.items : []) };
    if (!B && state.fw && window.PBFreeWallet && state.product && !(bs && bs.opt === 'bag')) body.items = window.PBFreeWallet.withGift(body.items, state.product.id, state.product.title);
    window.__pbLastBundleAdd = body.items;
    try { var ch = A && Alpine.store('xCartHelper'); if (ch && ch.getSectionsToRender) { body.sections = ch.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = location.pathname; } } catch (e) {}
    function clearSkel() { [].slice.call(D.querySelectorAll('.ab-atc-skel')).forEach(function (n) { n.remove(); }); }
    fetch((cfg.root || '/').replace(/\/?$/, '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { var er = new Error(j && (j.description || j.message) || 'HTTP ' + r.status); er.status = r.status; throw er; } return j; }); })
      .then(function (data) {
        var rendered = false;
        try {
          var ch2 = A && Alpine.store('xCartHelper');
          if (data && data.sections && ch2 && ch2.reRenderSections) {
            ch2.reRenderSections(data.sections);
            var n = countFromDom(); if (!isNaN(n)) ch2.currentItemCount = n;
            var mc2 = Alpine.store('xMiniCart'); if (mc2) { mc2.needReload = false; mc2.openCart(); }
            rendered = true;
          }
        } catch (e) {}
        if (!rendered) { try { var mc3 = A && Alpine.store('xMiniCart'); if (mc3) { mc3.needReload = true; if (mc3.reLoad) mc3.reLoad(); mc3.openCart(); } else location.href = cfg.cartUrl || '/cart'; } catch (e) {} }
        clearSkel();
        try { D.dispatchEvent(new CustomEvent('eurus:cart:items-changed')); } catch (e) {}
        atc.classList.remove('is-busy'); atc.textContent = 'Added';
        setTimeout(function () { if (B) { if (state.bundle === B) bundlePaint(B); } else if (state.variant === v) paintAtc(); }, 1600);
        refreshCount();
      })
      .catch(function (err) {
        /* a refused add (422: no more stock) is NOT success (Artist Booths item 388): close the drawer, say why, keep the view */
        clearSkel(); atc.classList.remove('is-busy');
        try { var mc4 = A && Alpine.store('xMiniCart'); if (mc4 && mc4.hideCart) mc4.hideCart(); } catch (e) {}
        showMsg(err && err.status === 422 ? (err.message || 'All the stock of this item is already in your cart.') : 'Could not add to cart. Please try again.');
      });
  }
  atc.addEventListener('click', addToCart);

  /* the cart drawer sits above: while it is open this view stands still (no Esc, no focus trap); when it closes, focus returns here */
  var wasCart = false;
  new MutationObserver(function () {
    var c = cartOpen();
    if (c === wasCart) return; wasCart = c;
    if (!c && state.open) {
      refreshCount();
      setTimeout(function () { if (!state.open || cartOpen()) return; var t = (cartOpener && root.contains(cartOpener) && !cartOpener.disabled) ? cartOpener : cartB; try { t.focus({ preventScroll: true }); } catch (e) {} }, 60);
    }
  }).observe(D.body, { attributes: true, attributeFilter: ['class'] });

  function lock() { D.documentElement.classList.add('pbqv-lock'); fitVV(); }
  function unlock() { D.documentElement.classList.remove('pbqv-lock'); fitVV(); }

  /* zoomed page (a pinch, or iPhone Safari zooming into a small text field): the fixed layer follows the LAYOUT viewport, so only
     its left part was on screen (title cut, colours and specs off the right edge, no quantity stepper). While open and zoomed, the
     layer sits on the VISIBLE viewport and is drawn at 1/zoom, so the sheet lays out and looks as it does unzoomed. Not zoomed:
     no inline styles at all (the normal path is unchanged). */
  var VV = window.visualViewport, vvOn = false;
  function fitVV() {
    if (!VV) return;
    var s = VV.scale || 1, st = root.style;
    if (!state.open || s < 1.02) {
      if (vvOn) { vvOn = false; root.classList.remove('is-vv'); st.left = st.top = st.right = st.bottom = st.width = st.height = st.transform = st.transformOrigin = ''; gkey = ''; }
      return;
    }
    vvOn = true; root.classList.add('is-vv');
    st.right = st.bottom = 'auto'; st.left = VV.offsetLeft + 'px'; st.top = VV.offsetTop + 'px';
    st.width = Math.round(VV.width * s) + 'px'; st.height = Math.round(VV.height * s) + 'px';
    st.transformOrigin = '0 0'; st.transform = 'scale(' + (1 / s) + ')';
    gkey = '';
  }
  if (VV) ['resize', 'scroll'].forEach(function (ev) { VV.addEventListener(ev, function () { if (!state.open && !vvOn) return; fitVV(); if (state.open) { geo(); pin(); } }, { passive: true }); });

  /* ── open / close ── */
  function open(href, opener, preferVid) {
    var handle = handleOf(href); if (!handle) return false;
    clearTimeout(closeTimer);
    state.bundle = null; root.classList.remove('is-bundle');
    state.bx = null; state.shownNow = 0; if (bundleEl) { bundleEl.hidden = true; bundleEl.innerHTML = ''; }
    var tok = ++state.tok;
    if (!state.open) back = opener || D.activeElement;
    state.handle = handle; state.ship = null; paintShip();
    var u; try { u = new URL(href, location.href); } catch (e) { u = null; }
    state.url = u ? u.pathname + (preferVid ? '?variant=' + preferVid : '') : href;
    link.href = state.url;
    /* instant first paint: the card's own photo + name while the data loads */
    var card = opener && opener.closest ? opener.closest('.card-product') : null;
    var cImg = card ? card.querySelector('a.x-labels-data img') : null;
    var cTitle = (opener && opener.getAttribute && opener.getAttribute('data-pv-title')) || (card && (card.querySelector('.x-card-title') || {}).textContent) || (opener && opener.getAttribute && opener.getAttribute('aria-label')) || '';
    if (!cImg && opener && opener.querySelector) cImg = opener.querySelector('img') || (opener.parentElement && opener.parentElement.querySelector('img'));
    cTitle = (cTitle || '').trim();
    barEl.textContent = cTitle;
    var cached = cache.get(handle), ready = null;
    if (cached && cached._v) ready = cached._v;
    if (ready) render(ready, preferVid);
    else {
      skeleton(cTitle);
      var src = cImg && (cImg.currentSrc || cImg.src);
      renderMedia(src ? [{ id: 'card', src: src.replace(/([?&])width=\d+&?/, '$1'), alt: cTitle }] : [], 0);
    }
    if (!state.open) {
      state.open = true;
      lock();
      root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
      scroller.scrollTop = 0; small = false; sheet.classList.remove('is-small'); gkey = '';
      requestAnimationFrame(function () { geo(); pin(); });
      try { sheet.focus({ preventScroll: true }); } catch (e) {}
      try { history.pushState(Object.assign({}, history.state || {}, { pbqv: handle }), '', state.url); pushed = true; } catch (e) { pushed = false; }
      refreshCount();
    }
    paintSpecs(handle, tok);
    poLoad(handle);
    if (!ready) {
      load(handle).then(function (p) {
        var pr = cache.get(handle); if (pr) pr._v = p;
        if (tok !== state.tok || !state.open) return;
        render(p, preferVid);
        requestAnimationFrame(function () { gkey = ''; geo(); pin(); });
      }).catch(function () {
        if (tok !== state.tok || !state.open) return;
        root.classList.remove('is-loading'); root.classList.add('is-error');
        optsEl.innerHTML = ''; priceEl.innerHTML = '';
        descEl.innerHTML = '<p class="pbqv__err">This product could not be loaded here. Open the full details instead.</p>';
        atc.disabled = true;
      });
    }
    return true;
  }
  function close(fromPop) {
    if (!state.open) return;
    state.open = false; state.tok++;
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    sheet.style.transform = ''; sheet.style.transition = '';
    unlock();
    if (!fromPop && pushed && history.state && history.state.pbqv) { ignorePop = true; setTimeout(function () { ignorePop = false; }, 800); try { history.back(); } catch (e) { ignorePop = false; } }
    pushed = false;
    var b = back; back = null;
    if (b && b.focus && D.contains(b)) { try { b.focus({ preventScroll: true }); } catch (e) {} }
    closeTimer = setTimeout(function () { if (!state.open) { track.innerHTML = ''; rail.innerHTML = ''; state.slides = []; if (specsEl) specsEl.innerHTML = ''; } }, 400);
  }
  var ignorePop = false;
  window.addEventListener('popstate', function (e) {
    if (ignorePop) { ignorePop = false; return; }
    if (state.open && !(e.state && e.state.pbqv)) close(true);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted && state.open) { pushed = false; close(true); } });
  [].slice.call(root.querySelectorAll('[data-pbqv-close]')).forEach(function (el) { el.addEventListener('click', function () { close(); }); });

  /* keys: Esc closes, Tab stays inside, arrows walk the photos (all paused while the cart drawer is on top) */
  D.addEventListener('keydown', function (e) {
    if (!state.open || cartOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      var f = [].slice.call(root.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function (n) { return n.offsetParent !== null || n === cartB; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = D.activeElement;
      if (!root.contains(a)) { e.preventDefault(); first.focus(); return; }
      if (e.shiftKey && (a === first || a === sheet)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
      return;
    }
    if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && !/^(INPUT|TEXTAREA|SELECT)$/.test((D.activeElement || {}).tagName || '')) {
      e.preventDefault(); snapTo(state.idx + (e.key === 'ArrowRight' ? 1 : -1));
    }
  });
  /* focus that escapes (e.g. a click on the page edge) comes back */
  D.addEventListener('focusin', function (e) { if (state.open && !cartOpen() && !root.contains(e.target) && !e.target.closest('#CartDrawer,[id^="CartDrawer"],.section-header')) { try { sheet.focus({ preventScroll: true }); } catch (err) {} } });

  /* drag the sheet down by its handle / title bar to close (phones and tablets). Only the sheet moves. */
  var drag = null;
  function dragEnd() { var d = drag; if (!d) return; drag = null; grab.classList.remove('is-drag'); try { grab.releasePointerCapture(d.id); } catch (err) {} }
  grab.addEventListener('pointerdown', function (e) {
    if (WIDE.matches || e.button > 0 || e.target.closest('button') || !state.open) return;
    drag = { id: e.pointerId, y0: e.clientY, dy: 0, t: e.timeStamp, v: 0 };
    try { grab.setPointerCapture(e.pointerId); } catch (err) {}
    grab.classList.add('is-drag'); sheet.style.transition = 'none';
  });
  grab.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    var dy = Math.max(0, e.clientY - drag.y0), dt = Math.max(1, e.timeStamp - drag.t);
    drag.v = (dy - drag.dy) / dt; drag.dy = dy; drag.t = e.timeStamp;
    sheet.style.transform = 'translateY(' + dy + 'px)';
  });
  function dragRelease(e) {
    if (!drag || (e && e.pointerId !== drag.id)) return;
    var shut = drag.dy > Math.min(140, sheet.clientHeight * 0.22) || (drag.v > 0.5 && drag.dy > 24);
    dragEnd(); sheet.style.transition = ''; sheet.style.transform = '';
    if (shut) close();
  }
  grab.addEventListener('pointerup', dragRelease); grab.addEventListener('pointercancel', dragRelease); grab.addEventListener('lostpointercapture', dragRelease);

  /* ── bundle mode: one view for a bag + sling + wallet set. openBundle({ title, pct, items: [{ handle, vid }], onPick(i, vid) })
     shows every item's photos in one carousel, each item with its own colour swatches, price and short description, the summed
     was price, the bundle price (pct off, matching the automatic discount) and one Add bundle to cart (all items, one /cart/add.js). ── */
  function bOn(B) { return B.items.filter(function (it) { return !it.off; }); }
  function bundleReady(B) { return bOn(B).every(function (it) { return it.v && it.v.available; }); }
  function bundleMedia(B) {
    var list = [];
    B.items.forEach(function (it) {
      it.m0 = list.length;
      var all = mediaList(it.p), fi = it.v && (it.v.featured_image ? it.v.featured_image.src : it.v.featured_media && it.v.featured_media.preview_image && it.v.featured_media.preview_image.src);
      var base = function (u) { return String(u || '').split('?')[0].replace(/^https?:/, ''); };
      var first = fi ? { id: 'v' + it.v.id, src: fi, alt: it.p.title } : all[0];
      if (first) list.push(first);
      all.filter(function (m) { return !first || base(m.src) !== base(first.src); }).slice(0, 3).forEach(function (m) { list.push(m); });
    });
    return list;
  }
  /*  the same maths and breakdown as every other bundle place (assets/pb-bundle.js): per line, the regular price is
     "was", the sale price less round(price x pct) is "now"; pct comes from how many items count a bag with any add-on saves 10%). */
  function bundleCalc(B) {
    var P = PBB(), lines = bOn(B).map(function (it) { var v = it.v || {}; return { key: it.handle, name: it.name || (it.p && P ? P.shortName(it.p.id, it.p.title) : (it.p || {}).title), price: v.price || 0, compare: v.compare_at_price || 0, qty: 1, elig: P ? P.eligible(it.p && it.p.id) : true }; });
    if (P) return P.calc(lines);
    var sum = 0, was = 0; lines.forEach(function (l) { sum += l.price; was += Math.max(l.price, l.compare); });
    var off = 0; lines.forEach(function (l) { off += Math.round(l.price * B.pct / 100); });
    return { pct: B.pct, lines: lines.map(function (l) { return { name: l.name, was: Math.max(l.price, l.compare), now: l.price - Math.round(l.price * B.pct / 100) }; }), was: was, now: sum - off, disc: off, saving: was - (sum - off) };
  }
  function bundlePaint(B, moveTo) {
    var P = PBB(), k = bundleCalc(B);
    titleEl.textContent = B.title; barEl.textContent = B.title;
    setNew(false);
    priceEl.className = 'pbqv__price is-sale is-bundle';
    priceEl.innerHTML = '<span class="pbqv__now">' + esc(money(k.now)) + '</span>' + (k.was > k.now ? '<s class="pbqv__was"><span style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">Regular price </span>' + esc(money(k.was)) + '</s>' : '') + (k.pct ? '<span class="pbqv__bsave">Save ' + k.pct + '%</span>' : '');
    paintFs(k.now, bOn(B).some(function (it) { return fsBag(it.p); }));
    optsEl.innerHTML = '<p class="pbqv__bhead">Bundle and save</p><p class="pbqv__bnote">' + esc(P ? P.sub() : 'Save an extra 10% with any add-on') + '</p>' + B.items.map(function (it, i) {
      var p = it.p, v = it.v, opts = it.off ? [] : realOptions(p), li = bOn(B).indexOf(it), ln = li >= 0 ? (k.lines[li] || {}) : {};
      var inc = i > 0 ? '<div class="pbqv__vals pbqv__inc" role="group" aria-label="' + esc(it.name || p.title) + '"><button type="button" class="pbqv__sw" data-inc="1" aria-pressed="' + !it.off + '"><span>Add it</span></button><button type="button" class="pbqv__sw" data-inc="0" aria-pressed="' + !!it.off + '"><span>None</span></button></div>' : '';
      var th = v && v.featured_image ? v.featured_image.src : (p.featured_image || '');
      var sw = opts.map(function (o, n) {
        return '<fieldset class="pbqv__opt" data-o="' + n + '"><legend class="pbqv__label">' + esc(o.name) + ': <b>' + esc(it.sel[n] || '') + '</b></legend><div class="pbqv__vals">' +
          o.values.map(function (val) {
            var vv = (p.variants || []).filter(function (x) { return x.options[n] === val && x.featured_image; })[0];
            var test = it.sel.slice(); test[n] = val; var m = findVariant(p, test), out = !m || !m.available, on = it.sel[n] === val;
            return '<button type="button" class="pbqv__sw' + (vv ? ' has-img' : '') + (out ? ' is-out' : '') + '" data-v="' + esc(val) + '" aria-pressed="' + on + '" aria-label="' + esc(val + (out ? ', sold out' : '')) + '">' + (vv ? '<img src="' + esc(img(vv.featured_image.src, 96)) + '" alt="" loading="lazy" decoding="async">' : '') + '<span>' + esc(val) + '</span></button>';
          }).join('') + '</div></fieldset>';
      }).join('');
      var d = desc(p.description);
      return '<section class="pbqv__bi" data-bi="' + i + '"><div class="pbqv__bih">' + (th ? '<img class="pbqv__bit" src="' + esc(img(th, 160)) + '" alt="" loading="lazy" decoding="async">' : '') +
        '<div class="pbqv__bit2"><a class="pbqv__bin" href="' + esc(p.url) + '">' + esc(it.name || p.title) + '</a><span class="pbqv__bip">' + (it.off ? '<span>Not added</span>' : v ? (ln.was > ln.now ? '<s>' + esc(money(ln.was)) + '</s> ' : '') + '<b>' + esc(money(ln.now)) + '</b>' : '') + '</span></div>' +
        '<button type="button" class="pbqv__bgo" data-bgo="' + i + '">Photos</button></div>' + inc + sw + (it.off ? '' : d.short ? '<div class="pbqv__bid">' + d.short + '</div>' : '') + '</section>';
    }).join('') + (P ? '<div class="pbqv__bd">' + P.breakdown(k, { cur: false }) + '</div>' : '');
    descEl.innerHTML = '';
    var ok = bundleReady(B);
    atc.disabled = !ok; atc.textContent = ok ? (bOn(B).length < 2 ? 'Add to cart \u2013 ' : 'Add bundle to bag \u2013 ') + money(k.now) : 'Sold out';
    if (moveTo != null) {
      renderMedia(bundleMedia(B), 0);
      var it = B.items[moveTo]; if (it && it.m0 != null) snapTo(it.m0, true);
    }
  }
  function bundlePick(e) {
    var B = state.bundle, go = e.target.closest('[data-bgo]');
    if (go) { var g = B.items[+go.getAttribute('data-bgo')]; if (g && g.m0 != null) snapTo(g.m0); return; }
    var ib = e.target.closest('[data-inc]'), ibox = ib && ib.closest('[data-bi]');
    if (ibox) { var ii = +ibox.getAttribute('data-bi'), itm = B.items[ii]; itm.off = ib.getAttribute('data-inc') === '0'; if (typeof B.onPick === 'function') { try { B.onPick(ii, itm.off ? 'none' : 'in'); } catch (err) {} } var y0 = scroller.scrollTop; bundlePaint(B); scroller.scrollTop = y0; return; }
    var b = e.target.closest('.pbqv__sw'), box = b && b.closest('[data-bi]'); if (!box) return;
    var i = +box.getAttribute('data-bi'), it = B.items[i], n = +b.closest('.pbqv__opt').getAttribute('data-o'), val = b.getAttribute('data-v');
    it.sel[n] = val;
    var v = findVariant(it.p, it.sel);
    if (!v || !v.available) { var alt = (it.p.variants || []).filter(function (x) { return x.options[n] === val && x.available; })[0]; if (alt) { v = alt; it.sel = alt.options.slice(); } }
    if (!v) return;
    it.v = v;
    if (typeof B.onPick === 'function') { try { B.onPick(i, v.id); } catch (err) {} }
    var y = scroller.scrollTop; bundlePaint(B, i); scroller.scrollTop = y;
  }
  function openBundle(cfgB, opener) {
    if (!cfgB || !cfgB.items || !cfgB.items.length) return false;
    clearTimeout(closeTimer);
    var tok = ++state.tok;
    if (!state.open) back = opener || D.activeElement;
    var B = { title: cfgB.title || 'Bundle and save', pct: +cfgB.pct || 0, onPick: cfgB.onPick, items: cfgB.items.map(function (x) { return { handle: x.handle, vid: x.vid, name: x.name, off: !!x.off }; }) };
    state.bundle = B; state.product = null; state.variant = null; state.ship = null; paintShip();
    state.bx = null; if (bundleEl) { bundleEl.hidden = true; bundleEl.innerHTML = ''; }
    state.handle = ''; state.url = location.pathname + location.search;
    root.classList.add('is-bundle');
    if (specsEl) specsEl.innerHTML = '';
    skeleton(B.title);
    var th = opener && opener.closest && opener.closest('[data-bundle]'); var ci = th && th.querySelector('img');
    renderMedia(ci ? [{ id: 'card', src: (ci.currentSrc || ci.src).replace(/([?&])width=\d+&?/, '$1'), alt: B.title }] : [], 0);
    if (!state.open) {
      state.open = true; lock();
      root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
      scroller.scrollTop = 0; small = false; sheet.classList.remove('is-small'); gkey = '';
      requestAnimationFrame(function () { geo(); pin(); });
      try { sheet.focus({ preventScroll: true }); } catch (e) {}
      try { history.pushState(Object.assign({}, history.state || {}, { pbqv: 'bundle' }), '', state.url); pushed = true; } catch (e) { pushed = false; }
      refreshCount();
    }
    Promise.all(B.items.map(function (it) { return load(it.handle).then(function (p) { var pr = cache.get(it.handle); if (pr) pr._v = p; return p; }); })).then(function (ps) {
      if (tok !== state.tok || !state.open || state.bundle !== B) return;
      root.classList.remove('is-loading', 'is-error');
      ps.forEach(function (p, i) {
        var it = B.items[i]; it.p = p;
        it.v = (p.variants || []).filter(function (x) { return String(x.id) === String(it.vid); })[0] || (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || null;
        it.sel = it.v ? it.v.options.slice() : [];
      });
      bundlePaint(B, 0);
      requestAnimationFrame(function () { gkey = ''; geo(); pin(); });
    }).catch(function () {
      if (tok !== state.tok || !state.open) return;
      root.classList.remove('is-loading'); root.classList.add('is-error');
      optsEl.innerHTML = ''; priceEl.innerHTML = '';
      descEl.innerHTML = '<p class="pbqv__err">This bundle could not be loaded here. Please try again.</p>';
      atc.disabled = true;
    });
    return true;
  }

  /* ── triggers: delegated, no card markup edits ──
     1) a plain left click on a product card's IMAGE link (a.x-labels-data); clicks on the card's own buttons inside it (photo
        arrows, quick add) are left alone, as are middle / cmd / ctrl / shift / alt clicks (the browser opens the product page).
     2) the theme's "Quick view" icon button on the card opens this view instead of the theme's own popup. */
  function cardLinkFor(el) { var c = el.closest('.card-product'); return c && c.querySelector('a.x-labels-data[href*="/products/"]'); }
  function excluded(el) { return !!el.closest('#CartDrawer,[id^="CartDrawer"],cart-drawer,.section-header,#pbqv,[data-pbqv-skip],.x-quickview-modal'); }
  D.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target; if (!t || !t.closest) return;
    var a = t.closest('.card-product a.x-labels-data[href*="/products/"]');
    if (!a || excluded(a)) return;
    var inter = t.closest('button,input,select,label,[role="button"],.splide__arrow,.splide__pagination');
    if (inter && a.contains(inter)) return;
    if (open(a.getAttribute('href'), a)) e.preventDefault();
  });
  D.addEventListener('click', function (e) {
    if (e.button !== 0) return;
    var t = e.target; if (!t || !t.closest) return;
    var qb = t.closest('.button-quickview-icon button,.button-quickview-icon [role="button"]');
    if (!qb || excluded(qb)) return;
    var a = cardLinkFor(qb); if (!a) return;
    e.preventDefault(); e.stopPropagation();
    open(a.getAttribute('href'), qb);
  }, true);
  /* warm the cache a moment before the click lands */
  D.addEventListener('pointerdown', function (e) {
    var a = e.target && e.target.closest && e.target.closest('.card-product a.x-labels-data[href*="/products/"]');
    if (a && !excluded(a)) { var h = handleOf(a.getAttribute('href')); if (h) load(h).then(function (p) { var pr = cache.get(h); if (pr) pr._v = p; }).catch(function () {}); }
  }, { passive: true, capture: true });

  /* 3) product-name pills any element with data-pbqv-pill opens this Preview for data-url (or its href).
     role=button + tabindex=0 in the markup; Enter / Space open it; modified / middle clicks on a link still follow it. */
  function pillOf(t) { var p = t && t.closest && t.closest('[data-pbqv-pill]'); return p && !excluded(p) ? p : null; }
  function pillUrl(p) { var u = p.getAttribute('data-url') || p.getAttribute('href') || ''; return u.indexOf('/products/') > -1 ? u : ''; }
  D.addEventListener('click', function (e) {
    var p = pillOf(e.target); if (!p) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { if (p.tagName !== 'A') e.stopPropagation(); return; }
    var u = pillUrl(p); if (!u) return;
    e.preventDefault(); e.stopPropagation();
    open(u, p);
  }, true);
  D.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var p = pillOf(e.target); if (!p || p !== e.target) return;
    var u = pillUrl(p); if (!u) return;
    e.preventDefault(); e.stopPropagation();
    open(u, p);
  }, true);
  D.addEventListener('pointerover', function (e) {
    var p = pillOf(e.target); if (!p || p._pbqvWarm) return; p._pbqvWarm = 1;
    var u = pillUrl(p); if (u) window.pbQuickView && window.pbQuickView.prefetch(u);
  }, { passive: true });

  window.pbQuickView = { prefetch: function (href) { var h = handleOf(href); if (!h) return; load(h).then(function (p) { var pr = cache.get(h); if (pr) pr._v = p; }).catch(function () {}); loadSpecs(h).catch(function () {}); }, open: function (href, opener) { var pv = null; try { pv = new URL(href, location.href).searchParams.get('variant'); } catch (e) {} return open(href, opener || null, pv); }, openBundle: function (b, opener) { return openBundle(b, opener || null); }, close: function () { close(); }, isOpen: function () { return state.open; } };
})();
